const CAMPAIGN_STATUS_LIST = [
  {
    key: "pending",
    label: "campaigns.status_list.pending",
    class: "bg-pending",
    color: "#9AEF75",
  },
  {
    key: "active",
    label: "campaigns.status_list.active",
    class: "bg-active",
    color: "#EF5858",
  },
  {
    key: "changed",
    label: "campaigns.status_list.changed",
    class: "bg-changed",
    color: "#e6b400",
  },
  {
    key: "reserved",
    label: "campaigns.status_list.reserved",
    class: "bg-reserved",
    color: "#88B0F7",
  },
  {
    key: "cancelled",
    class: "bg-cancelled",
    label: "campaigns.status_list.cancelled",
  },
  {
    key: "rejected",
    class: "bg-rejected",
    label: "campaigns.status_list.rejected",
    color: "#191e23",
  },
  {
    key: "ended",
    class: "bg-ended",
    label: "campaigns.status_list.ended",
    color: "#",
  },
];

export default CAMPAIGN_STATUS_LIST;
